import { IApiCopyType } from '@api/interfaces/data-contracts';
import { EnumUTACopyTAInvestorFormField } from '@components-member/TradingAccounts/CopyTradingAccounts/enums';
import {
  MARGIN_STOP_COPY_LEVEL,
  PERCENTAGE_LOSS_STOP_COPY_LEVEL,
  LOT_FIELD,
  STOP_COPY_VIA_MARGIN_LEVEL,
} from '@components-member/shared/forms/formFields';
import { IFormField } from '@components-shared/forms/formField.interface';
import { keyMap } from '@locales/lokalise/keyMap';
import generator from 'components/shared/forms/formGenerator';

export const FIELDS_INVESTOR: IFormField[] = [
  {
    name: EnumUTACopyTAInvestorFormField.accountType,
    title: keyMap.sharedFieldsAccountType,
    type: 'customSelect',
    options: [],
    attributes: { autoComplete: 'off', disabled: true },
    required: true,
  },
  {
    name: EnumUTACopyTAInvestorFormField.copyType,
    title: keyMap.tradingAccountsCopyType,
    type: 'customSelect',
    options: [],
    attributes: { autoComplete: 'off', disabled: false },
    required: true,
  },
  { ...LOT_FIELD },
  {
    name: EnumUTACopyTAInvestorFormField.leverage,
    title: keyMap.commonLeverage,
    type: 'customSelect',
    options: [],
    attributes: { autoComplete: 'off', disabled: true },
    required: true,
  },
  { ...MARGIN_STOP_COPY_LEVEL },
  { ...STOP_COPY_VIA_MARGIN_LEVEL },
  { ...PERCENTAGE_LOSS_STOP_COPY_LEVEL },
];

type InvestorSettingsFormContext = {
  props: {
    lotFieldHandler: (copyType: IApiCopyType) => void;
  };
};

export const Form = generator(FIELDS_INVESTOR, {
  copyType: (ctx: InvestorSettingsFormContext, value: IApiCopyType) => {
    const { lotFieldHandler } = ctx.props;

    lotFieldHandler(value);
  },
});
